import styled from 'styled-components';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const ConfirmationModalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;

function ConfirmAllValuesModal({
  isOpen,
  onConfirm,
  onCancel,
}: {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <Dialog
      visible={isOpen}
      style={{ width: '450px' }}
      header="Confirm ALL entries"
      modal
      footer={
        <>
          <Button label="Cancel" icon="pi pi-times" size="small" text onClick={onCancel} />
          <Button label="Confirm" icon="pi pi-check" size="small" onClick={onConfirm} />
        </>
      }
      onHide={onCancel}
    >
      <ConfirmationModalWrapper>
        <i className="pi pi-exclamation-triangle" style={{ fontSize: '2rem' }} />
        <span>
          Do you really want to <strong>confirm</strong> ALL report entries?
        </span>
      </ConfirmationModalWrapper>
    </Dialog>
  );
}

export default ConfirmAllValuesModal;
